export default __webpack_public_path__ + "static/media/farmlands_delivery_c.b7d53538.mp4";